<script setup lang="ts">
import LeLogoLemma from "@dsk/icons/LeLogoLemma.vue";
import LeLogoOrdbogen from "@dsk/icons/LeLogoOrdbogen.vue";

import { config } from "@/config";

const { site } = config.app;
</script>

<template>
  <LeLogoOrdbogen v-if="site === 'ordbogen'" />
  <LeLogoLemma v-else />
</template>
